import { createContext, useContext } from "react";
import usePWA from "./usePWA";

const PWAContext = createContext(null);

export const PWAProvider = ({ children }) => {
  const pwa = usePWA();
  return (
    <PWAContext.Provider value={pwa}>
      {children}
    </PWAContext.Provider>
  );
};

export const usePWAContext = () => useContext(PWAContext);